import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import styled from "styled-components";

export const CardStyle = styled(Card)`
  transition: all ease 0.25s;
  cursor: pointer;
  &:active {
    transform: scale(0.95);
  }
`;
export const BodyStyled = styled(CardBody)`
  display: flex;
  align-items: center;
`;
export const TitleStyled = styled.h4`
  margin: 0 0 0 0.5rem;
`;
